import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  OnInit,
} from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { toSignal } from '@angular/core/rxjs-interop';
import { SidebarService } from '@core/components/sidebar/service/sidebar.service';
import {
  provideSidebarItemStore,
  SidebarItemStore,
  SubPage,
} from '@core/components/sidebar/components/sidebar-item/sidebar-item.store';
import { SidebarItemCollapsedComponent } from '@core/components/sidebar/components/sidebar-item/item/collapsed/sidebar-item-collapsed.component';
import { SidebarItemExpandedComponent } from '@core/components/sidebar/components/sidebar-item/item/expanded/sidebar-item-expanded.component';

@Component({
  selector: 'app-sidebar-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideSidebarItemStore()],
  imports: [SidebarItemCollapsedComponent, SidebarItemExpandedComponent],
  template: `
    @if (!collapsed()) {
      <app-sidebar-item-expanded />
    } @else {
      <app-sidebar-item-collapsed />
    }
  `,
})
export class SidebarItemComponent implements OnInit {
  /** INJECTIONS **/
  /****/
  private readonly service = inject(SidebarService);

  /****/
  private readonly store = inject(SidebarItemStore);

  /** INPUTS **/
  /****/
  readonly icon = input.required<IconProp>();

  /****/
  readonly label = input.required<string>();

  /****/
  readonly path = input.required<string>();

  /****/
  readonly subPages = input<SubPage[]>();

  /** PROPERTIES **/
  /****/
  protected readonly collapsed = toSignal(this.service.sidebarCollapsed$);

  public ngOnInit() {
    this.store.init(
      this.icon(),
      this.label(),
      this.path(),
      this.subPages() ?? null
    );
  }
}

export function getLinkItemClasses(isActive: boolean) {
  const activeBg = 'bg-greenish-25 dark:bg-greenish-800';
  const activeBorder = 'border-greenish-500';
  const activeText = 'font-medium text-greenish-500';

  const notActiveBg = `bg-transparent hover:bg-greenish-25 dark:hover:bg-greenish-800`;
  const notActiveBorder = 'border-transparent hover:border-greenish-500';
  const notActiveText = 'dark:text-dune-0 hover:text-greenish-500';

  return {
    [`${activeBg} ${activeBorder} ${activeText}`]: isActive,
    [`${notActiveBg} ${notActiveBorder} ${notActiveText}`]: !isActive,
  };
}
